export default {
  detail: '/income/client/card/detail',
  list: '/income/client/activity/list'
}
